import KngScormCompleteStandard from './src/main';

/* istanbul ignore next */
KngScormCompleteStandard.install = function(Vue) {
  Vue.component(KngScormCompleteStandard.name, KngScormCompleteStandard);
};

export default KngScormCompleteStandard;
